import { pciPalPostData } from '~/types/pciPal/postMessage';
import { generateMaskedCcNumber } from '~/utils/generateMaskedCcNumber';

export const parsePciPal = (data: unknown) => {
  const parsed = pciPalPostData.parse(data);
  const fullResponse = parsed.VariableData.FullResponse.Value;
  const domParser = new DOMParser();
  const xml = domParser.parseFromString(fullResponse, 'text/xml');
  xml.getElementsByTagNameNS('*', 'replyMessage');
  const transactionId = xml.getElementsByTagNameNS('*', 'paymentNetworkTransactionID')[0]
    ?.textContent;
  if (!transactionId) throw new Error('transaction id not found');
  const maskedCardNumber = generateMaskedCcNumber(
    parsed.VariableData.PAN.Bin,
    parsed.VariableData.PAN.Last4,
    parsed.VariableData.PAN.DigitsCollected
  );
  return {
    transactionId,
    processorResponse: parsed.VariableData.processorResponse.Value,
    decision: parsed.VariableData.Decision.Value,
    reasonCode: parsed.VariableData.reasonCode.Value,
    cardType: parsed.VariableData.cardType.Value,
    totalAmount: parsed.VariableData.authAmount.Value,
    maskedCardNumber,
    cardToken: parsed.VariableData.subscriptionID.Value,
    expiryMonth: parsed.VariableData.Expiry.Month,
    expiryYear: parsed.VariableData.Expiry.FullYear,
    creditCardCVV: 'x'.repeat(parsed.VariableData.CV2.DigitsCollected),
    cardholderName: parsed.VariableData.cardholderName.Value,
  };
};
